export enum StorageAreaType {
  Undefined = 0,
  Producer = 1,
  Consumer = 2,
  Vehicle = 3,
  LogSorterIntake = 4,
  SawLineIntake = 5,
  LogSorterBin = 6,
  SortedPile = 7,
  UnsortedPile = 8,
  Truck = 9,
  Train = 10,
  CoilStack = 11,
  Bulk = 12
}

export function isLogYard(type: StorageAreaType) {
  switch (type) {
    case StorageAreaType.SortedPile:
    case StorageAreaType.UnsortedPile:
    case StorageAreaType.LogSorterBin:
    case StorageAreaType.LogSorterIntake:
    case StorageAreaType.SawLineIntake:
      return true;
  }

  return false;
}

export function isLogYardPile(type: StorageAreaType) {
  switch (type) {
    case StorageAreaType.SortedPile:
    case StorageAreaType.UnsortedPile:
      return true;
  }

  return false;
}

export function isCoilStorage(type: StorageAreaType) {
  switch (type) {
    case StorageAreaType.CoilStack:
      return true;
  }

  return false;
}

export function isBulkStorage(type: StorageAreaType) {
  switch (type) {
    case StorageAreaType.Bulk:
      return true;
  }

  return false;
}
